import React from 'react';
import BrowsingCardName from "../../../productCard/common/BrowsingCardName";
import TableHeading from "../../../TableHeading";
import CarrierLogo from "../../../productCard/common/CarrierLogo";

import Spinner from "../../../Spinner";
import { createStyles } from "./styles";
























var MultiVariantsHeading = function MultiVariantsHeading(_ref)





{var portfolio = _ref.portfolio,isPortfolioAddedToCart = _ref.isPortfolioAddedToCart,headingContent = _ref.headingContent,variantsAmount = _ref.variantsAmount,_ref$loaderInPortfoli = _ref.loaderInPortfolioId,loaderInPortfolioId = _ref$loaderInPortfoli === void 0 ? '' : _ref$loaderInPortfoli;
  var classes = createStyles({ variantsAmount: variantsAmount });
  return /*#__PURE__*/(
    React.createElement(TableHeading, { className: classes.multiVariantsHeading }, /*#__PURE__*/
    React.createElement(CarrierLogo, { carrier: portfolio.products[0].carrier, styles: classes.portfolioLogo }), /*#__PURE__*/
    React.createElement(BrowsingCardName, {
      name: portfolio.name,
      wrapperStyles: classes.nameWrapper,
      isPortfolioInProposal: isPortfolioAddedToCart,
      showSelectedIcon: true }), /*#__PURE__*/

    React.createElement("div", { className: classes.variantsHeadings }, headingContent),
    loaderInPortfolioId === portfolio.id && /*#__PURE__*/
    React.createElement("div", { className: classes.spinnerWrapper }, /*#__PURE__*/
    React.createElement(Spinner, { size: "8rem" }))));




};

export default MultiVariantsHeading;
//# sourceMappingURL=index.js.map